let mapboxCssPromise: Promise<void> | null = null;

export function ensureMapboxCss() {
  if (typeof window === "undefined" || process.env.NODE_ENV === "test") {
    return Promise.resolve();
  }

  const isChromatic =
    (typeof process !== "undefined" && (process as any).env?.CHROMATIC) ||
    (typeof import.meta !== "undefined" && (import.meta as any).env?.CHROMATIC);

  if (isChromatic) {
    return Promise.resolve();
  }

  if (!mapboxCssPromise) {
    mapboxCssPromise = import("mapbox-gl/dist/mapbox-gl.css")
      .then(() => {
        // no-op: css is applied as a side-effect
      })
      .catch((error) => {
        console.error("Failed to load Mapbox CSS", error);
        mapboxCssPromise = null;
      });
  }

  return mapboxCssPromise;
}
